import { MNSproCloudApi } from '..';
import { CourseNotebookResponse } from '../api/v2';
import {
  MissingNotebookCreateResult,
  MissingNotebookResult,
  NotebookEntitiesTypes,
} from './Notebooks.interface';

export class NotebooksService {
  private static getCourseApi = (authToken: string) => {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.CoursesApiFactory(config);

    return api;
  };

  /**
   * Retrieves a list of workgroups that are missing the notebook
   */
  static async getAllWorkgroupsWithMissingNotebook(
    authToken: string,
    organizationId: string,
  ): Promise<MissingNotebookResult[]> {
    const api = MNSproCloudApi.V2.WorkgroupsApiFactory(
      MNSproCloudApi.V2.createConfiguration(authToken),
    );
    const response = await api.getWithMissingNotebook(organizationId);

    return response.data.map(workgroup => ({
      groupId: workgroup.id,
      displayName: workgroup.displayName,
      type: NotebookEntitiesTypes.Workgroup,
      jobId: workgroup.notebookJobId ?? null,
    }));
  }

  static async getAllCoursesWithMissingNotebooks(
    authToken: string,
    organizationId: string,
  ): Promise<MissingNotebookResult[]> {
    const api = NotebooksService.getCourseApi(authToken);
    const response = await api.getWithMissingNotebook(organizationId);

    return response.data
      .map(course => ({
        groupId: course.id,
        displayName: course.displayName,
        type: 'course',
        jobId: course.notebookJobId ?? null,
      }))
      .filter(
        (result): result is MissingNotebookResult =>
          !!result.groupId && !!result.displayName,
      );
  }

  static async createNotebooks(
    authToken: string,
    organizationId: string,
    groupIds: string[],
    entityType: NotebookEntitiesTypes,
  ): Promise<MissingNotebookCreateResult[]> {
    const api = NotebooksService.getCourseApi(authToken);
    const response = await api.createNotebooks(organizationId, groupIds);

    return response.data
      .map(result => ({
        entityId: result.id,
        displayName: result.displayName,
        entityType,
        creationState: result.creationState,
        errorCode: result.errorCode,
        jobId: result.jobId,
      }))
      .filter(
        (result): result is MissingNotebookCreateResult =>
          result.displayName !== undefined,
      );
  }

  static async getNotebook(
    authToken: string,
    organizationId: string,
    groupId: string,
  ): Promise<CourseNotebookResponse> {
    const api = NotebooksService.getCourseApi(authToken);
    const response = await api.getNotebook(organizationId, groupId);

    return response.data;
  }
}
